export function getDynamicGreeting(): string {
  const now = new Date();
  const hour = now.getHours();

  if (hour < 12) {
    return 'Good Morning';
  } else if (hour < 18) {
    return 'Good Afternoon';
  } else {
    return 'Good Evening';
  }
}

export function getGreetingWithTimezone(timezone?: string): string {
  try {
    // If timezone is provided, use it; otherwise use system timezone
    const options: Intl.DateTimeFormatOptions = {
      hour: 'numeric',
      hour12: false,
      timeZone: timezone
    };

    const formatter = new Intl.DateTimeFormat('en-US', options);
    const hourString = formatter.format(new Date());
    const hour = parseInt(hourString);

    if (hour < 12) {
      return 'Good Morning';
    } else if (hour < 18) {
      return 'Good Afternoon';
    } else {
      return 'Good Evening';
    }
  } catch (error) {
    // Fallback to system time if timezone is invalid
    return getDynamicGreeting();
  }
}